import {TravelTarifficationStep} from "./steps/TravelTarifficationStep";
import { TravelUserDetailsStep } from "./steps/TravelUserDetailsStep";
import { TravelVerificationStep } from "./steps/TravelVerificationStep";


export const steps: any = {
    "travel_online_00001": TravelTarifficationStep,
    "travel_online_00002": TravelUserDetailsStep,
    "travel_online_00003": TravelVerificationStep
};